;(function(w){
	function Menu(){
		var self = this;
		this.main = document.getElementById('menu');

		var arr_btns = [];

		//visited active
		$(this.main).find('li').each(function(index){
			arr_btns[index] = new MenuBtn(this);
		})

		$(this.main).css('width', (arr_btns.length)*66);

		this.set = function(route_key){
			/*var index_actual = arr_btns.length - 1;*/
			var index_actual = 0;

			arr_btns.forEach(function(item, index){
				if(item.getRouteKey() == route_key){
					item.setActive(true);
					index_actual = index;
				}else{
					item.setActive(false);
				}	
			})

			$(self.main).css('left', -(index_actual)*66);
		}

	}
	
	w.Menu = Menu;
})(window)